/**
 * The last time the reader used the console, shared by every tab of the
 * origin.
 *
 * The idle sign-out counts input in any tab, so a reader working in one tab is
 * not signed out of the others. Local storage is where the tabs already meet
 * (`useCrossTabAuthSync` rides the same `storage` event), so the time is kept
 * here rather than in each tab's memory.
 */
export const ACTIVITY_STORAGE_KEY = "everythingcloud-last-activity";

/** The last recorded activity (epoch ms), or `null` when none was recorded. */
export function readLastActivity(): number | null {
  try {
    const raw = window.localStorage.getItem(ACTIVITY_STORAGE_KEY);
    if (raw == null) return null;
    const at = Number(raw);
    return Number.isFinite(at) && at > 0 ? at : null;
  } catch {
    return null;
  }
}

/** Record activity now (or at `at`), for this tab and the others. */
export function recordActivity(at: number = Date.now()): void {
  try {
    window.localStorage.setItem(ACTIVITY_STORAGE_KEY, String(at));
  } catch {
    // Storage full or blocked: this tab's own clock still counts it.
  }
}
